module.exports = __webpack_public_path__ + "static/img/logo.1c949a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/login/logo.png
// module id = v5AY
// module chunks = 1